export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8694.cb546b81.jpg";